import { useEffect } from "react"
import { GetImage } from "../actions"

export const LoadImage=({imageAddress,width,height})=>{
    return <img src={GetImage(imageAddress)} width={width} height={height} />;
}